"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Deviantart;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Deviantart(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#010101;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "Deviantart"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "deviantart",
    className: "cls-1",
    d: "M75.01,24.553l-15.35,28,1.157,1.485H75.01V73.994H49.859l-2.11,1.438-6.831,13.13c-.047,0-1.344,1.344-1.438,1.438H24.99V75.432L39.558,47.39,38.4,45.952H24.99V26.006H49.375l2.11-1.438,6.831-13.13c.047,0,1.344-1.344,1.438-1.438H75.01Z"
  })));
}